// extracted by mini-css-extract-plugin
export default {"supporter-message-box":"CGaZg"};